export default __webpack_public_path__ + "fonts/Panton-Regular.ttf";